import { useQuery } from '@tanstack/react-query';
import { rollingReactionQueryKey } from 'queries/rollingReaction/queryKey';
import { RollingReactionApi } from 'api/ApiHelper';

export const useGetRollingReactionQuery = (rollingId: number) =>
  useQuery({
    queryKey: rollingReactionQueryKey.rolling(rollingId),
    queryFn: async () => RollingReactionApi.getMyReaction(rollingId),
  });
